import { podFulFillmentUtils } from '@thd-olt-component-react/fulfillment';
import * as constants from './constants';

const {
  CONFIGURABLE_BLINDS, HOME_DEPOT_DESIGN_CENTER, SCHEDULE_A_MEASURE_URL,
  PRODUCT_POD_V7_CLICK
} = constants;

const {
  isLiveGoods,
  getSellableQuantityYourStore
} = podFulFillmentUtils;

export const isBuildAndBuyProduct = (product) => {
  const { identifiers } = product || {};

  return identifiers?.productType === CONFIGURABLE_BLINDS;
};

const isCustomCabinet = (productSubType) => {
  const { link = '' } = productSubType || {};
  const checkCustomCabinet = /BRIO_INAISLE_SFI_CABINETS/.test(link);
  return checkCustomCabinet;
};

export const checkScheduleAMeasureEligibility = (product) => {
  return !!(product?.installServices?.scheduleAMeasure);
};

export const isBrioProduct = (product) => {
  const { info } = product || {};
  const { isBrioSku, isCustomKitchenCabinet, productSubType } = info || {};
  return (isBrioSku && !(isCustomCabinet(productSubType) || isCustomKitchenCabinet));
};

export const isCustomKitchenCabinetProduct = (product) => {
  const { info } = product || {};
  const { isBrioSku, isCustomKitchenCabinet, productSubType } = info || {};
  return (isBrioSku && (isCustomCabinet(productSubType) || isCustomKitchenCabinet));
};

export const isLiveGoodsOOSProduct = (product) => {
  return (isLiveGoods(product) && !getSellableQuantityYourStore(product));
};

export const getCustomBlindsUrl = ({
  productType,
  blindsHost,
  canonicalUrl,
  merchQueryParam
}) => {
  const configureProduct = productType === CONFIGURABLE_BLINDS;
  const regex = /\/p\//gi;
  const customBlindsPath = '/p/custom-blinds/';
  const customProductUrl = canonicalUrl && canonicalUrl.replace(regex, customBlindsPath);
  const getCanonicalUrl = (merchQueryParam !== undefined && merchQueryParam !== null)
    ? `${canonicalUrl}?${merchQueryParam}` : `${canonicalUrl}`;

  return (configureProduct) ? `${blindsHost}${customProductUrl}` : getCanonicalUrl;
};

export const getCustomUrlWithAnalytics = ({
  productType,
  blindsHost,
  canonicalUrl,
  merchQueryParam
}) => {
  let productUrl = getCustomBlindsUrl({
    productType, blindsHost, canonicalUrl, merchQueryParam
  });

  return productUrl;
};

export const isHDDCSku = (product) => {
  return product?.details?.installation?.serviceType === HOME_DEPOT_DESIGN_CENTER
    || product?.info?.productSubType?.name === HOME_DEPOT_DESIGN_CENTER;
};

export const sendPodTapperAnalytics = (event, itemId, url) => {
  if (!window) return;

  const clickedElement = event?.target;

  // Find the PodTapper container to limit DOM traversal scope
  const podTapperContainer = clickedElement?.closest('[data-testid="pod-tapper"]');

  // Comprehensive early detection: Check clicked element and ancestors for ANY interactive behavior
  const hasInteractiveElement = (element) => {
    if (!element || !podTapperContainer) return false;
    // First check: Direct interactive properties on clicked element
    const isDirectlyInteractive = element && (
      (element.tagName === 'A' || element.tagName === 'BUTTON' || element.tagName === 'SPAN')
      && (
        element.onclick
        || element.getAttribute('onclick')
        || element.getAttribute('role') === 'button'
        || element.getAttribute('role') === 'link'
        || element.hasAttribute('href')
      )
    );

    if (isDirectlyInteractive) return true;

    // Traverse ancestors within PodTapper scope (max 5 levels)
    let current = element;
    let depth = 0;
    const maxDepth = 5;
    const selectors = [
      'a[href]',
      'a[onclick]',
      'button',
      '[onclick]',
      '[role="button"]',
      '[role="link"]'
    ];

    while (current && current !== podTapperContainer.parentElement && depth < maxDepth) {
      depth += 1;
      // If we reach the PodTapper container, stop here
      if (current === podTapperContainer) break;

      // Check for React handlers on current element
      const reactInstance = Object.keys(current).find((key) => key.startsWith('__reactInternalInstance'));
      const reactEventHandlers = Object.keys(current).find((key) => key.startsWith('__reactEventHandlers'));
      const fiberFromInstance = reactInstance ? current[reactInstance] : null;
      const eventHandlers = reactEventHandlers ? current[reactEventHandlers] : null;

      if (fiberFromInstance?.memoizedProps?.onClick || eventHandlers?.onClick) return true;
      // Check if current element matches any JS selector (JS handlers, buttons, links, etc.)
      for (let i = 0; i < selectors.length; i += 1) {
        const selector = selectors[i];
        if (current.matches && current.matches(selector)) return true;
      }
      current = current.parentElement;
    }
    return false;
  };

  // Check for any interactive behavior (comprehensive single check)
  const hasInteractiveElementFound = hasInteractiveElement(clickedElement);

  if (hasInteractiveElementFound) return; // Exit early, don't preventDefault or trigger analytics

  // Only prevent default and continue if no interactive elements found
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }
  const podTapperEventData = {
    podAction: 'pod tapper',
    podAnchorSku: itemId,
    target: '_self',
    parent: 'plp'
  };
  window.LIFE_CYCLE_EVENT_BUS.trigger(PRODUCT_POD_V7_CLICK, podTapperEventData);
  setTimeout(() => {
    window.location.href = url;
  }, 100);
};
